export default "__VITE_ASSET__CpzMPx9a__"